/**
 * Load Autocomplete js
 */

const loadAutocomplete = () => {
    if (!!!autocompleteLoaded) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = autocompleteScript;
        document.body.appendChild(script);

        autocompleteLoaded = true;
    }
}

export default loadAutocomplete;
